import { FaDiscord, FaTwitter } from "react-icons/fa";
import { BsXLg } from "react-icons/bs";
import { MobileMenuStyleWrapper, StyledLogo } from "./MobileMenu.style";
import { useState } from "react";
import { useAccount, useDisconnect } from "wagmi";
import { ConnectButton } from "../../../common/ConnectButton";
import OpenseaSVG from "../../../../assets/images/icon/opensea";
import Button from "../../../../common/button";

const MobileMenu = ({ mobileMenuhandle, headerStyles }) => {
  const { disconnect } = useDisconnect();
  const { isConnected } = useAccount();
  const [isSubmenu, setSubmenu] = useState(false);

  const handleSubmenu = () => {
    setSubmenu(!isSubmenu);
  };

  return (
    <MobileMenuStyleWrapper className="hermes_mobile_menu">
      <div className="hermes_mobile_menu_content">
        <div className="mobile_menu_logo">
          <StyledLogo variant={headerStyles} />
          <button
            className="mobile_menu_close_btn"
            onClick={() => mobileMenuhandle()}
          >
            {" "}
            <BsXLg />{" "}
          </button>
        </div>
        <div className="hermes_mobile_menu_list">
          <ul>
            <li className="submenu mobile_submenu" onClick={handleSubmenu}>
              <a href="# ">Home +</a>
              <ul
                className={`sub_menu_list mobile_sub_menu_list ${
                  isSubmenu === true && "submenu_hovered"
                }`}
              >
                <li className="mobile_menu_hide">
                  <a href="/">Home One</a>
                </li>
                <li className="mobile_menu_hide">
                  <a href="/home-two">Home Two</a>
                </li>
                <li className="mobile_menu_hide">
                  <a href="/home-three">Home Three</a>
                </li>
              </ul>
            </li>
            <li className="mobile_menu_hide">
              <a href="#about">About</a>
            </li>
            <li className="mobile_menu_hide">
              <a href="#roadmap">Roadmap</a>
            </li>
            <li className="mobile_menu_hide">
              <a href="#team">Team</a>
            </li>
            <li className="mobile_menu_hide">
              <a href="#faq">FAQ</a>
            </li>
          </ul>
        </div>
        <div className="mobile_menu_social_links">
          <a href="# ">
            <OpenseaSVG />
          </a>
          <a href="# ">
            <FaTwitter />
          </a>
          <a href="# ">
            <FaDiscord />
          </a>
        </div>
        {isConnected ? (
          <Button
            sm
            variant="hovered"
            className="connect_btn"
            onClick={() => disconnect()}
          >
            Disconnect
          </Button>
        ) : (
          <ConnectButton sm />
        )}
      </div>
    </MobileMenuStyleWrapper>
  );
};

export default MobileMenu;
